// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "spa-assets/js/vendors/vue-router") return "spa-assets/js/vendors/vue-router-fde5834bcd78c2a1a99b.m.js";
	// return url for filenames based on template
	return undefined;
};